import React, { Fragment, PureComponent, useState, useEffect, useContext, useReducer, useMemo, useCallback } from 'react';
import { connect, Provider } from 'react-redux';
import { merge, get, clone, set, findIndex } from 'lodash';
import moment from 'moment';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import { withRouter, useHistory, useParams, useLocation, useRouteMatch } from 'react-router';
import { useDispatch, useMappedState, StoreContext } from 'redux-react-hook';
import { Modal, Button, Icon, InputItem, Carousel, ActionSheet, Toast } from 'antd-mobile';
import { Loading } from '../../../components/loading';
import { VBottomNav } from '../../../components/copyright/common';
import { uploadImg, setHomepageStatus } from '../../commonAction';
import { getTopicList, getSportList, handleImgData, handleIndexData, getTopicConfigList, getBannerConfigList, getActivityConfigList, getPlacardItemList, setGalleryImgPraise, setNewsPraise, setCancelNewsPraise } from './action';
import { getWeixinConfig, configWeixin, MINIPROGRAM_APPID } from '../../../utils/weixin';
import { getImgInfo, getDownloadQRCode, sendDownloadInfo } from '../idetail/action';
import { getNewsList } from '../news/action';
import { getUploadToken } from '../upload/action';
import { base64ToBlob, blobToFile, readCookie, isVideoUrl, createCookie } from '../../../utils/common';
import { DetailShare } from '../../../components/copyright/detailShare';
import { ShareBtn } from '../../../components/icons/share';
import { ShareTip } from '../../../components/copyright/shareTip';
import { ImageInfo } from '../../../components/copyright/imageInfo';
import { DownloadTip } from '../../../components/downloadTip';
import { TextDialog } from '../../../components/textDialog';
import { CommonFooter } from '../../../components/copyright/commonFooter';
import { HeaderImages } from '../../../components/copyright/headerImages';
// import Tloader from 'react-touch-loader';
import Tloader from '../../../components/loader';
import Vfalls from '../../../components/falls';
import LazyLoad from 'vanilla-lazyload';
import { Vh5Video } from '../../../components/videoPaler';
import { _track } from '../../../utils/track';
import {isMiniApp} from '../../../utils/miniApp';
import { PhotoProvider, PhotoConsumer, PhotoSlider } from 'react-photo-view';
import copy from 'copy-to-clipboard';
import 'react-photo-view/dist/index.css';
import './index.scss';
const mapStateToProps = state => {
	return {
		sportList: state.CopyrightHomeReducers.sportList,
		totalCount: state.CopyrightHomeReducers.totalCount,
		pageIndex: state.CopyrightHomeReducers.pageIndex,
		pageSize: state.CopyrightHomeReducers.pageSize,
		albumList: state.CopyrightHomeReducers.albumList,
		placardItemList: state.CopyrightHomeReducers.placardItemList,
		isUpdate: state.CopyrightHomeReducers.isUpdate,
		topicConfigList: state.CopyrightBaseinfoReducers.topicConfigList,
		bannerConfigList: state.CopyrightBaseinfoReducers.bannerConfigList,
		activityConfigList: state.CopyrightBaseinfoReducers.activityConfigList,
		baseInfo: state.CopyrightBaseinfoReducers.baseinfo,
		newsList: state.CopyrightNewsReducers.newsList
	};
};
let lazyLoadInstance = null;
let initCount = 0;
let activityWidth = window.innerWidth < 599 ? window.innerWidth - 40 + 'px' : '460px';
function CopyrightHome(props) {
	let praiseState = true;
	let history = useHistory();
	const mapState = useCallback(mapStateToProps, []);
	const {
		newsList = [],
		topicConfigList = [],
		bannerConfigList = [],
		activityConfigList = [],
		sportList = [],
		placardItemList = [],
		albumList = [],
		totalCount,
		pageIndex,
		pageSize,
		isUpdate,
		baseInfo
	} = useMappedState(mapState);
	let [isShowLoading, setIsShowLoading] = useState(false);
	let [effectFlag, setEffectFlag] = useState(1);
	const [pageData, setPageData] = useState({
		isShowShareTip: false,
		newsId: null
	});
	const [cache, setCache] = useState(() => {
		return get(props, 'location.state.cache', false);
	});
	let [playerOptions, setPlayerOptions] = useState({});
	let [bannerDetailCustom, setBannerDetailCustom] = useState('');
	let [downloadItem, setDownloadItem] = useState({});
	let [isDownloadTip, setIsDownloadTip] = useState(false);
	let [detailList, setDetailList] = useState([]);
	const [visible, setVisible] = React.useState(false);
  const [photoIndex, setPhotoIndex] = React.useState(0);
	let dispatch = useDispatch();
	let location = useLocation();
	const [imgInfo, setImgInfo] = useState({
		id: '',
		contentId: '',
		type: 1,
		userId: 11610,
		userNickname: '4119昵称',
		key: '',
		thumbKey: '',
		picDescription: '',
		description: '',
		submitTime: 0,
		crDate: 0,
		lat: null,
		city: '',
		width: 600,
		height: 885,
		size: 32513,
		authorUserName: null,
		authorUserId: null,
		workTraceResps: []
	});
	let handleLoadMore = resolve => {
		if (pageIndex * pageSize >= totalCount) {
			return;
		}
		let userId = readCookie('copyrightuserId') || 0;
		dispatch(
			getPlacardItemList(
				{
					index: pageIndex + 1,
					limit: pageSize,
					userId: parseInt(userId, 10)
				},
				data => {
					_track({
						trackName: 'toutu_home_page',
						payload: {
							index: pageIndex + 1,
							limit: pageSize,
							page_action_name: 'home-tloader-activity'
						}
					});
					resolve();
				}
			)
		);
	};
	let handleRefresh = (resove, reject) => {
		console.log('重新上拉加载刷新逻辑');
		resove();
	};
	function onPlayer({ id, topicId, url, type }) {
		const videoJsOptions = {
			autoplay: true,
			controls: true,
			fluid: true,
			controlBar: {
				fullscreenToggle: false
			},
			sources: [
				{
					src: url,
					type: type || 'video/mp4'
				}
			],
			data: {
				id,
				topicId,
				url
			},
			closeCallback: () => {
				setPlayerOptions({});
			}
		};
		setPlayerOptions(videoJsOptions);
	}
	function onToidetail(item, index) {
		_track({
			trackName: 'toutu_home_page',
			payload: {
				index,
				page_action_name: 'activity-to-idetail'
			}
		});
		if (item.newsType===2) {
			history.push({
				pathname: '/vpmobile/copyright/newsDetail/'+item.id,
			});
		} else {
			let top = document.getElementsByClassName('tloader')[0].scrollTop;
			console.log('top', top);
			if (item.type === 2) {
				onPlayer({
					id: item.id,
					topicId: item.topicId,
					url: item.thumbVideoUrl,
					type: ''
				});
				return;
			}
			let objectProps = clone(defaultProps);
			let newItems = objectProps.items.filter(item => {
				if (item.type === 2) {
					return false;
				}
				return true;
			});
			let newArray = handleIndexData(placardItemList, index);
			console.log('newArray', newArray, placardItemList, top);
			let itemCount = newArray.items.length;
			
			let group_description_index = itemCount === 1 ? 0 : index;
			let detailIndex = newArray.items.findIndex(item => {
				return item.isCover;
			});
			history.push({
				pathname: '/vpmobile/copyright/idetail',
				state: {
					defaultProps: newArray,
	//				topicName: detail.name,
					index: detailIndex<0 ? 0 : detailIndex, // matchIndex,
					// sectionDescription: newArray.items[group_description_index].group_description,
					sectionDescription: item.sectionDescription,
					topicId: item.id,
					pathname: `/vpmobile/copyright/home`,
					top
				}
			});
		}
	}
	function toActivity(item) {
		_track({
			trackName: 'toutu_home_page',
			payload: {
				page_action_name: 'home-to-idetail',
				indexpage_Action: '活动浏览'
			}
		});
		//处理微信授权的问题 通过history.push 方式会导致打开activity分享空白
		window.location.href = '/vpmobile/copyright/activity/' + item.id + '/home';
	}
	function remainDaysTip(timestamp) {
		let ms = timestamp - new Date().getTime();
		if (ms <= 0) {
			return '活动已结束';
		}
		return `活动将于${Math.ceil(ms / 1000 / 3600 / 24)}天后结束`;
	}
	function handleClickShareBtn(newsId) {
		pageData.isShowShareTip = true;
		pageData.newsId = newsId;
		setPageData({ ...pageData });
		_track({
			trackName: 'toutu_home_page',
			payload: {
				page_action_name: 'home-button-wxshare',
				indexpage_Action: '分享'
			}
		});
	}
	function handleClickShareTip() {
		pageData.isShowShareTip = false;
		setPageData({ ...pageData });
	}
	useEffect(() => {
		setIsShowLoading(true);
		let userId = readCookie('copyrightuserId') || 0;
		// if (effectFlag === 1) {
		if (!cache || (effectFlag === 1 && placardItemList.length === 0)) {
			setCache(true);
			setEffectFlag(2);
			lazyLoadInstance = new LazyLoad({
				elements_selector: '.lazy',
				load_delay: 300
				// ... more custom settings?
			});
			dispatch(
				getTopicList({ index: 1, limit: 1 }, () => {
					++initCount;
					_track({
						trackName: 'toutu_home_page',
						payload: {
							index: 1,
							limit: 1,
							page_action_name: 'home-init-toutu'
						}
					});
				})
			);
			dispatch(
				getPlacardItemList(
					{
						index: 1,
						limit: 7,
						userId: parseInt(userId, 10)
					},
					data => {
						++initCount;
						_track({
							trackName: 'toutu_home_page',
							payload: {
								index: 1,
								limit: 7,
								page_action_name: 'home-init-activity'
							}
						});
					}
				)
			);
			if (!get(newsList, ['length'], 0)) {
				dispatch(getNewsList({ index: 1, limit: 10, userId: parseInt(userId, 10) }));
			}
			if (!get(topicConfigList, ['length'], 0)) {
				dispatch(getTopicConfigList(null));
			}
			if (!get(bannerConfigList, ['length'], 0)) {
				dispatch(getBannerConfigList(null));
			}
			if (!get(activityConfigList, ['length'], 0)) {
				dispatch(getActivityConfigList(null));
			}
			dispatch(
				getWeixinConfig({ url: window.location.href }, data => {
					console.log('getWeixinConfig', data);
					configWeixin(data, {
						title: '投图',
						desc: '主题影像即时创作平台'
					});
					_track({
						trackName: 'toutu_home_page',
						payload: {
							...data,
							page_action_name: 'home-init-wxconfig'
						}
					});
				})
			);
		} else if (effectFlag === 1 && cache) {
			setEffectFlag(2);
			lazyLoadInstance = new LazyLoad({
				elements_selector: '.lazy',
				load_delay: 0
				// ... more custom settings?
			});
			let top = get(props, 'location.state.top', 0);
			document.getElementsByClassName('tloader')[0].scrollTop = top;
		}
		setIsShowLoading(false);
	}, [dispatch, effectFlag, topicConfigList, cache, props, newsList, bannerConfigList, activityConfigList, placardItemList]);
	useEffect(() => {
		console.log('render....', initCount);
		if (initCount === 2 && !lazyLoadInstance) {
			//必须登录到2个请求完毕才操作
			lazyLoadInstance = new LazyLoad({
				elements_selector: '.lazy',
				load_delay: 300
				// ... more custom settings?
			});
		} else if (initCount === 2) {
			lazyLoadInstance.update();
		}
		return () => {
			console.log('离开');
			return lazyLoadInstance && lazyLoadInstance.update();
		};
	});

	const actTypeIcons = {
		1: {
			iconFn: <i className={'iconfont public-benefit'}>&#xe662;</i>,
			text: '公益活动',
			className: 'public-benefit'
		},
		2: {
			iconFn: <i className={'iconfont reward'}>&#xe665;</i>,
			text: '悬赏活动',
			className: 'reward'
		},
		3: {
			iconFn: <i className={'iconfont flash'}>&#xe66b;</i>,
			text: '快闪活动',
			className: 'flash'
		}
	};
	function ActTypeIcon(prop) {
		let item = prop.item;
		let category = item.category;
		if (!category) {
			return '';
		}
		let type = actTypeIcons[category];
		return (
			<span className="act-type">
				{actTypeIcons[item.category].iconFn}
				<span className="text">{actTypeIcons[item.category].text}</span>
			</span>
		);
	}
	// function handleScroll(e) {
	// 	const panel = document.querySelector('.copyright-home .tloader');
	// 	console.log(panel.scrollTop);
	// 	if (panel.scrollTop > 200) {
	// 		console.log(666);
	// 		// document.querySelector('.copyright-home .fixed-search').style.display = 'block';
	// 	} else {
	// 		// document.querySelector('.copyright-home .fixed-search').style.display = 'none';
	// 	}
	// }
	function getBannerUrl(index) {
		let obj = bannerConfigList[index];
		if (obj.bannerDetailUrl && !obj.bannerDetailCustom) {
			return obj.bannerDetailUrl;
		}
		if (!obj.bannerDetailUrl && obj.bannerDetailCustom) {
			return obj.bannerDetailUrl;
		}
	}
	function handleClickBanner(val) {
		if (val.bannerDetailUrl && !val.bannerDetailCustom) {
			let globalFlag = 0;
			(async () => {
				globalFlag = await isMiniApp();
				if (globalFlag === 1) {
					Modal.alert('这是一个外部链接', '小程序不支持打开外部链接,可点击复制按钮后在浏览器中粘贴查看', [
				    { text: '取消', onPress: () => console.log('cancel'), style: 'default' },
				    { text: '复制链接', onPress: () => {
				    		console.log('ok');
				    		copy(val.bannerDetailUrl);
				    		Toast.success('复制成功');
				    	}
				    },
				  ]);
				} else {
					window.location.href = val.bannerDetailUrl;
				}
			})();
			return;
		}
		if (!val.bannerDetailUrl && val.bannerDetailCustom) {
			setBannerDetailCustom(val.bannerDetailCustom);
			return;
		}
	}
	function Vh5BannerDetail(prop) {
		return (
			<div style={{ position: 'fixed', top: '0', left: '0', width: '100vw', height: '100vh', background: '#000', zIndex: '111' }}>
				<div onClick={closeBannerDetail} style={{ position: 'absolute', top: '25px', left: '25px' }} className="back-btn">
					<i className="iconfont arrow" style={{ color: '#fff' }}>
						
					</i>
					<span style={{ color: '#fff' }}>返回</span>
				</div>
				<div style={{ marginTop: '74px' }} dangerouslySetInnerHTML={{ __html: prop.detail }}></div>
			</div>
		);
	}
	function closeBannerDetail() {
		setBannerDetailCustom('');
	}
	function getCurrentImgInfo(item) {
		console.log(item);
		// let item = items[index - 1];
		let { contentId } = item;
		dispatch(
			getImgInfo({ contentId }, data => {
				_track({
					trackName: 'toutu_idetail_page',
					payload: {
						...data,
						page_action_name: 'idetail-imginfo'
					}
				});
				setImgInfo(data);
				console.log('img info', data);
			})
		);
	}
	function onMore(item, index) {
		console.log(item, index);
		let textArray = ['视频信息', '下载视频', '取消'];
		ActionSheet.showActionSheetWithOptions(
			{
				options: textArray,
				//message: '上传照片、视频',
				maskClosable: true,
				wrapProps: {
					// onTouchStart: e => e.preventDefault()
				}
			},
			buttonIndex => {
				console.log(buttonIndex);
				if (buttonIndex === 0) {
					getCurrentImgInfo(item);
					pageData.isShowInstruction = true;
					setPageData(clone(pageData));
					//视频信息
				} else if (buttonIndex === 1) {
					//视频下载
					// showQRCode(item);
					setDownloadItem(item);
					onOpenTip();
				}
			}
		);
	}
	function onOpenTip() {
		setIsDownloadTip(true);
	}
	function onOpenTipNext() {
		setIsDownloadTip(false);
		showQRCode(downloadItem);
	}
	function onCloseTip() {
		setIsDownloadTip(false);
	}
	function onPraise(item, index) {
		if (!praiseState) {
			return;
		}
		praiseState = false;
		dispatch(
			getUploadToken(null, data => {
				if (data.code !== 0) {
					createCookie('userToken', '', 180);
					Modal.alert('提示', '登录过期，是否去登录？', [
						{ text: '再看看', onPress: () => {} },
						{
							text: '去登录',
							onPress: () => {
								window.location.href = '/vpmobile/copyright/login?redirect_pathname=' + encodeURIComponent(window.location.pathname);
							}
						}
					]);
					return;
				}
				console.log('praise', item);
				let userId = readCookie('copyrightuserId') || window['copyrightuserId'];
				if (item.newsType === 1) {
					dispatch(
						setGalleryImgPraise(
							{
								operation: item.likeStatus === 0 ? 1 : 0,
								postId: item.sectionId,
								userId: baseInfo.id,
								index,
								name: 'home'
							},
							data => {
								praiseState = true;
							},
							data => {
								praiseState = true;
							}
						)
					);
				} else if (item.newsType === 2) {
					if (item.likeStatus === 0) {
						dispatch(
							setNewsPraise(
								{
									index,
									userId: userId,
									projectionNewsId: item.id
								},
								data => {
									praiseState = true;
								},
								data => {
									praiseState = true;
								}
							)
						);
					} else {
						dispatch(
							setCancelNewsPraise(
								{
									index,
									userId: userId,
									projectionNewsId: item.id
								},
								data => {
									praiseState = true;
								},
								data => {
									praiseState = true;
								}
							)
						);
					}
				}
			})
		);
	}
	function formatSource(list) {
		function formatItem(item) {
			let d = new Date(item.operateTime);
			let hour = String(d.getHours());
			let minute = String(d.getMinutes());
			let second = String(d.getSeconds());
			if (hour.length === 1) {
				hour = '0' + hour;
			}
			if (minute.length === 1) {
				minute = '0' + minute;
			}
			if (second.length === 1) {
				second = '0' + second;
			}
			return {
				time: hour + ':' + minute + ':' + second,
				operate: item.operate,
				comment: item.comment
			};
		}
		let stamps = [];
		let dataList = [];
		list.forEach(item => {
			let d = new Date(item.operateTime);
			let date = d.getDate();
			let month = d.getMonth() + 1;
			let year = d.getFullYear();
			let stamp = year + '.' + month + '.' + date;
			item = formatItem(item);
			if (!stamps.includes(stamp)) {
				stamps.push(stamp);
				dataList.push([item]);
			} else {
				dataList[dataList.length - 1].push(item);
			}
		});
		console.log([stamps, dataList]);
		return [stamps, dataList];
	}
	function source(resps) {
		let [stamps, dataList] = formatSource(resps);

		let iconMap = {
			SHOOT: '&#xe65d;',
			ORG_STMT: '&#xe660;',
			PUBLISH: '&#xe65c;'
		};
		function items(sourceList) {
			return sourceList.map(item => {
				return `<li>
						<span class="time">${item.time}</span>
						<span class="operate iconfont">${iconMap[item.operate] || ''}</span>
						<span class="comment">${item.comment}</span>
					</li>`;
			});
		}
		let list = stamps.map((stamp, index) => {
			return `<ul>
					<h3 class="date">${stamp}</h3>
					${items(dataList[index]).join('')}
				</ul>`;
		});

		return `<ul class="workTraceResps">${list.join('')}</ul>`;
	}
	function imageInfo(info) {
		//let { imgLayout = 'JPEG', imgSize = '4.3MB', imgPx = '6140 × 4912 像素', dateString = '2020年02月04日 12:00', author = 'Frank Wang' } = info || {};
		function videotype(key) {
			let index = key.lastIndexOf('.') + 1;
			return key.slice(index);
		}
		let equipment = ''; // 传输设备
		let location = imgInfo.city;
		let originalDocId = imgInfo.contentId;
		let isOriginal = imgInfo.isOriginal === 20; // 10：否  20：是
		let imgLayout = imgInfo.type === 1 ? 'JPEG' : videotype(imgInfo.key);
		let imgSize = parseFloat(imgInfo.size / 1024).toFixed(2) + 'KB';
		let imgPx = imgInfo.width + ' x ' + imgInfo.height + ' 像素';
		let dateString = moment(imgInfo.submitTime).format('YYYY-MM-DD HH:mm');
		let author = imgInfo.authorUserName || '未知';
		let resps = imgInfo.workTraceResps;
		return (
			'<div class="img-info-dialog">' +
			'<ul>' +
			(equipment ? `<li><label>传输设备</label><span>${equipment}</span></li>` : '') +
			'    <li>' +
			'        <label>视频格式</label>' +
			'        <span>' +
			imgLayout +
			'</span>' +
			'    </li>' +
			'    <li>' +
			'        <label>视频大小</label>' +
			'        <span>' +
			imgSize +
			'</span>' +
			'    </li>' +
			'    <li>' +
			'        <label>拍摄地点</label>' +
			'        <span>' +
			location +
			'</span>' +
			'    </li>' +
			'    <li>' +
			'        <label>视频尺寸</label>' +
			'        <span>' +
			imgPx +
			'</span>' +
			'    </li>' +
			'    <li>' +
			'        <label>原始文档ID</label>' +
			'        <span>' +
			originalDocId +
			'</span>' +
			'    </li>' +
			'</ul>' +
			'<ul>' +
			'    <li>' +
			'        <label>视频溯源</label>' +
			(isOriginal ? '<div class="original"><span class="iconfont original-icon">&#xe660;</span><span>原创</span><div>' : '') +
			'    </li>' +
			// '    <li>' +
			// '        <label>照片提交于</label>' +
			// '        <span>' +
			// dateString +
			// '</span>' +
			// '    </li>' +
			// '    <li>' +
			// '        <label>照片提交者</label>' +
			// '        <span>' +
			// author +
			// '</span>' +
			// '    </li>' +
			'</ul>' +
			source(resps) +
			// '<ul>' +
			// '    <li>' +
			// '        <label>版权说明</label>' +
			// '        <span>可免费使用，但不可用于商业+用途，使用请注明出处。第三方权利说明：已获得模特肖像权授权</span>' +
			// '    </li>' +
			// '</ul>' +
			'</div>'
		);
	}
	function dialogFooter() {
		pageData.isShowInstruction = false;
		setPageData(clone(pageData));
	}
	function toCopyrightNotice() {
		history.push({
			pathname: '/vpmobile/copyright/notice'
		});
	}
	function onShare(item, index) {
		_track({
			trackName: 'toutu_home_page',
			payload: {
				id: item.id,
				shareType: item.newsType === 2 ? '新闻' : '作品',
				page_action_name: 'home-share'
			}
		});
		if (item.newsType === 2) {
			handleClickShareBtn(item.id);
		} else {
			let shareData = {
				fromAvatar: item.avatar,
				fromName: item.nickname,
				// topicName: item.section,
				// title: item.description,
				// sectionId: item.sectionId,
				// contentId: item.contentId,
				title: item.sectionDescription,
				thumbKey: item.url, //item.thumbKey || item.smallUrl
				// list: [{
				// 	key: item.url,
				// 	description: item.description
				// }]
			};
			if (item.mutil || isVideoUrl(item.url)) {
				shareData.sectionId = item.sectionId;
				shareData.list = placardItemList[index].topicContentResponses;
			} else {
				shareData.contentId = item.contentId;
				shareData.list = [
					{
						key: item.url, //item.originalUrl || item.url,
						description: item.description
					}
				];
			}
			pageData.sharedData = shareData;
			pageData.isShowShare = true;
			setPageData({ ...pageData });
			console.log('showShare', shareData);
		}
	}
	function closeShare() {
		pageData.isShowShare = false;
		setPageData({ ...pageData });
	}
	function showQRCode(item) {
		if (pageData.isShowDownload) {
			return;
		}
		pageData.isShowDownload = true;
		setPageData({ ...pageData });

		// let _index = carouselIndex === -1 ? index : carouselIndex;
		let fd = new FormData();
		fd.append('appId', MINIPROGRAM_APPID);
		fd.append('downloadUrl', item.originalUrl);
		dispatch(
			getDownloadQRCode(
				fd,
				data => {
					pageData.isShowQRcodeInstruction = true;
					pageData.QRContent =
						'<div class="qrcode-wrap">' +
						'<img width="162" height="162" src="' +
						data.miniAppQrUrl +
						'" alt="小程序二维码" />' +
						'<div class="tip2">长按识别小程序码下载本视频</div>' +
						'</div>';
					setPageData(clone(pageData));
					_track({
						trackName: 'toutu_idetail_page',
						payload: {
							...data,
							page_action_name: 'idetail-dialog-qrcode'
						}
					});
					// return '<div class="qrcode-wrap">' + '<img width="162" height="162" src="' + data.miniAppQrUrl + '" alt="小程序二维码" />' + '<div class="tip2">长按识别小程序码下载本图</div>' + '</div>';
					uploadDownloadInfo(item.contentId);
				},
				data => {
					console.log('error data', data);
					Toast.fail('生成小程序码失败');
					_track({
						trackName: 'toutu_idetail_page',
						payload: {
							...data,
							page_action_name: 'idetail-dialog-qrcode'
						}
					});
				}
			)
		);
	}
	function uploadDownloadInfo(contentId) {
		let userId = readCookie('copyrightuserId');
		dispatch(
			sendDownloadInfo(
				{
					contentIds: [contentId],
					userId
				},
				data => {},
				data => {
					console.log('error data', data);
				}
			)
		);
	}
	let defaultProps = handleImgData(placardItemList);
	console.log('defaultProps.......', defaultProps);
	return (
		<div className="copyright copyright-home">
			<div className="gallery-top-nav">
				<div className="header-events">
					<div className="search-input">
						<Icon className="search-icon" type="search" size="sm"></Icon>
						<InputItem
							className="search-inner"
							placeholder="搜索图片、视频、活动"
							onFocus={() => {
								history.push({ pathname: '/vpmobile/copyright/search/1' });
							}}></InputItem>
					</div>
				</div>
			</div>
			<Tloader
				initializing={2}
				onRefresh={handleRefresh}
				hasMore={true}
				onLoadMore={handleLoadMore}
				autoLoadMore={pageIndex * pageSize < totalCount /*false不会触发onLoadMore*/}
				className="tloader some class">
				<header style={{ display: 'none' }}>
					<div className="info">{/* <h2>投图</h2>
						<p className="des">专业的摄影照片版权交易平台</p> */}</div>
					<ShareBtn className="share-btn" onClick={handleClickShareBtn} />
				</header>
				{/* <div className="fixed-search">
					<InputItem
						className="search-input"
						onFocus={() => {
							history.push({ pathname: '/vpmobile/copyright/search/1'});
						}}
						placeholder="搜索图片、视频、活动"
					/>
					<Icon className="search-icon" type="search" size='sm'/>
				</div> */}
				{get(bannerConfigList, ['length'], 0) ? (
					<section className="banner-section">
						<Carousel autoplay infinite autoplayInterval={5000}>
							{bannerConfigList.map((val = {}, index) => (
								<div key={'banner-' + index} style={{ display: 'inline-block', width: '100%', height: '160px' }} onClick={handleClickBanner.bind(this, val)}>
									<img
										src={val.bannerCover}
										alt=""
										style={{ width: '100%', verticalAlign: 'top' }}
										onLoad={() => {
											// fire window resize event to change height
											// window.dispatchEvent(new Event('resize'));
											// this.setState({ imgHeight: 'auto' });
										}}
									/>
								</div>
							))}
						</Carousel>
					</section>
				) : (
					''
				)}
				{get(topicConfigList, [topicConfigList.findIndex(item => item.specialHomeExhibition), 'specialItemResps', 'length'], 0) ? (
					<section className="hot-topic-section">
						<h2>
							热门专题
							<span
								className="more"
								onClick={() => {
									history.push({ pathname: '/vpmobile/copyright/topic' });
								}}>
								更多专题
								<Icon className="icon-right" type="right" />
							</span>
						</h2>
						<ul className="topic-list" data-c={get(topicConfigList, [topicConfigList.findIndex(item => item.specialHomeExhibition), 'specialItemResps'], []).slice(0, 9).length % 3}>
							{get(topicConfigList, [topicConfigList.findIndex(item => item.specialHomeExhibition), 'specialItemResps'], [])
								.map(element => {
									return (
										<li
											key={element.id}
											onClick={() => {
												history.push({
													pathname: '/vpmobile/copyright/search/1',
													state: {
														globalSearchString: get(element, 'specialTag', '')
													}
												});
											}}>
											<img alt="" src={get(element, 'specialCover', '')} />
											<span>#{get(element, 'specialTag', '')}</span>
										</li>
									);
								})
								.slice(0, 9)}
							{get(topicConfigList, [topicConfigList.findIndex(item => item.specialHomeExhibition), 'specialItemResps'], []).slice(0, 9).length % 3 === 2 ? <li></li> : ''}
						</ul>
					</section>
				) : (
					''
				)}
				{newsList&&get(newsList, 'length', 0) ? (
					<section className="news-section"
						onClick={() => {
							history.push({ pathname: '/vpmobile/copyright/news' });
						}}>
						<div className="news-container">
							<div className="news-img">
								<i>&#xe673;</i>
							</div>
							<div className="news-list">
								{newsList.map((item, index)=>{
									if (index < 2) {
										return (
											<div key={item.id} className="news-item" onClick={event=>{
												event.stopPropagation();
												history.push({pathname: '/vpmobile/copyright/newsDetail/'+item.id});
											}}>{item.title}</div>
										)
									}
								})}
								<Icon className="icon-right" type="right" />
							</div>
						</div>
					</section>
				) : (
					''
				)}
				{get(activityConfigList, ['length'], 0) ? (
					<section className="activity-section activities">
						<h2>
							活动<span className="op">原创主题影像征集</span>
							<span
								className="more"
								onClick={() => {
									history.push({ pathname: '/vpmobile/copyright/events' });
								}}>
								更多活动
								<Icon className="icon-right" type="right" />
							</span>
						</h2>
						<Carousel
							cellSpacing={10}
							slideWidth={activityWidth}
							autoplay
							infinite
							autoplayInterval={5000}
							style={{
								padding: '10px 0 30px 0'
							}}>
							{activityConfigList.map((item = {}, index) => (
								<div key={'activity-' + index} to={'/vpmobile/copyright/activity/' + item.id + '?' + item.id} onClick={toActivity.bind(this, item)}>
									<div className="item-box">
										<img alt="" className="cover lazy" src={item.url} />
										<h3>
											<span className="iconfont topic"></span>
											{item.name}
										</h3>
										<p className="des">{remainDaysTip(moment(item.endTime))}</p>
										{item.endTime > new Date().getTime() ? <div className="button">立即参与</div> : <div className="button over">活动已结束</div>}
										<ActTypeIcon item={item} />
									</div>
								</div>
							))}
						</Carousel>
					</section>
				) : (
					''
				)}
				{get(placardItemList, ['length'], 0) ? (
					<section className="placard-section">
						<h2>精选推荐</h2>
						<Vfalls {...defaultProps} isDesc={true} onClick={onToidetail} onMore={onMore} onShare={onShare} onPraise={onPraise} update={isUpdate} />
						{pageIndex * pageSize < totalCount ? <Loading /> : <div className="text">---- 我是底线，不能更低了 ----</div>}
					</section>
				) : (
					''
				)}
				<CommonFooter />
			</Tloader>
			<VBottomNav activeName="home" />
			{isDownloadTip ? <DownloadTip isDownloadTip={isDownloadTip} imgInfo={[downloadItem]} index={0} onClose={onCloseTip} onOpenTipNext={onOpenTipNext}></DownloadTip> : ''}
			{pageData.isShowShareTip ? <ShareTip path='/vpmobile/copyright/newsDetail/' id={pageData.newsId} onClick={handleClickShareTip} /> : ''}
			{playerOptions && playerOptions.sources ? <Vh5Video {...playerOptions} /> : ''}
			{bannerDetailCustom ? <Vh5BannerDetail detail={bannerDetailCustom} /> : ''}
			{pageData.isShowShare ? <DetailShare data={pageData.sharedData} onClose={closeShare} /> : ''}
			{pageData.isShowInstruction ? <ImageInfo text={imageInfo()} clickFooter={dialogFooter} clickIcon={toCopyrightNotice} footer={'关闭'} isVideo={true} /> : ''}
			{pageData.isShowQRcodeInstruction ? <TextDialog title="视频下载" text={pageData.QRContent} clickFooter={dialogFooter} footer={'关闭'} /> : ''}
			{/*<PhotoSlider
        images={detailList.map(item => ({ src: item.originalUrl }))}
        visible={visible}
        onClose={() => setVisible(false)}
        index={photoIndex}
        onIndexChange={setPhotoIndex}
      />*/}
			{/*{visible?<PhotoProvider>
				{detailList.map((item, index) => {
          return (<PhotoConsumer key={index} src={item.originalUrl} intro={item.intro}>
            <img src={item.originalUrl}/>
          </PhotoConsumer>)
				})}
			</PhotoProvider>:''}*/}
			{isShowLoading ? <div className="loading-cover"><Loading /></div> : ('')}
		</div>
	);
}
export { CopyrightHome };
